module.exports = __webpack_public_path__ + "static/PersonDrawingDesktop-5d015c9ec668940943433db848a8e3a1.jpg";